import { render, staticRenderFns } from "./EditPatientDepartmentNote.vue?vue&type=template&id=de92c25a&scoped=true"
import script from "./EditPatientDepartmentNote.vue?vue&type=script&lang=js"
export * from "./EditPatientDepartmentNote.vue?vue&type=script&lang=js"
import style0 from "./EditPatientDepartmentNote.vue?vue&type=style&index=0&id=de92c25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de92c25a",
  null
  
)

export default component.exports